import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Scenario, Material } from '../../types/models';

interface ScenarioState {
  scenarios: Scenario[];
  currentScenario: Scenario | null;
  loading: boolean;
  error: string | null;
}

const initialState: ScenarioState = {
  scenarios: [],
  currentScenario: null,
  loading: false,
  error: null,
};

export const scenarioSlice = createSlice({
  name: 'scenario',
  initialState,
  reducers: {
    fetchScenariosStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchScenariosSuccess: (state, action: PayloadAction<Scenario[]>) => {
      state.scenarios = action.payload;
      state.loading = false;
      state.error = null;
    },
    fetchScenarioSuccess: (state, action: PayloadAction<Scenario>) => {
      state.currentScenario = action.payload;
      state.loading = false;
      state.error = null;
    },
    fetchScenarioFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
    createScenarioSuccess: (state, action: PayloadAction<Scenario>) => {
      state.scenarios.push(action.payload);
      state.loading = false;
      state.error = null;
    },
    updateScenarioSuccess: (state, action: PayloadAction<Scenario>) => {
      state.scenarios = state.scenarios.map(scenario => 
        scenario.scenarioId === action.payload.scenarioId ? action.payload : scenario
      );
      if (state.currentScenario && state.currentScenario.scenarioId === action.payload.scenarioId) {
        state.currentScenario = action.payload;
      }
      state.loading = false;
      state.error = null;
    },
    deleteScenarioSuccess: (state, action: PayloadAction<string>) => {
      state.scenarios = state.scenarios.filter(scenario => scenario.scenarioId !== action.payload);
      if (state.currentScenario && state.currentScenario.scenarioId === action.payload) {
        state.currentScenario = null;
      }
      state.loading = false;
      state.error = null;
    },
    clearScenarioError: (state) => {
      state.error = null;
    },
  },
});

export const {
  fetchScenariosStart,
  fetchScenariosSuccess,
  fetchScenarioSuccess,
  fetchScenarioFailure,
  createScenarioSuccess,
  updateScenarioSuccess,
  deleteScenarioSuccess,
  clearScenarioError,
} = scenarioSlice.actions;

export default scenarioSlice.reducer;
